import { Component, Input } from "@angular/core";

@Component({
  selector: "ab-country",
  templateUrl: "./country.component.html",
})
export class CountryComponent {
  @Input() public code: string;
  @Input() public country: string;
  @Input() public showUnknownCountry: boolean;
}
